
export const getPromotionalOfferViewStyles = () => ({
  promotionalOfferContainer: {
    minHeight: '140px',
    boxShadow: '0 1.6px 3.6px 0 rgba(0,0,0,15%)',
    display: 'flex',
    flexDirection: 'column',
  },
  offerHelpLink: {
    height: 20,
    fontSize: 14,
    paddingTop: 3,
    marginBottom: 8,
    textDecoration: 'underline',
  },
  signupCouponDetails: {
    display: 'flex',
    flexDirection: 'row',
  },
  myCurrentOffer: {
    display: 'flex',
    fontSize: 14,
    flexDirection: 'column',
  },
  actionButton: {
    marginTop: '10px',
    marginBottom: '10px',
    width: 'fit-content',
  },
  promotionalCodeInputContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '24px',
    paddingLeft: '24px',
    paddingRight: '24px',
  },
  promotionalCodeLabel: {
    paddingBottom: '7px',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  promotionalCodeInput: {
    fieldGroup: {
      maxWidth: '416px',
    },
  },
  promotionalOfferContent: {
    marginLeft: '24px',
    marginTop: '12px',
    marginBottom: '4px',
  },
  promotionalOfferShimmer: {
    margin: '24px',
  },
});
